import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const styles = {
  card: {
    // maxWidth: 345,
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  name: {
    minHeight: '5rem'
  }
};

class CourseCard extends Component {
  render() {
    const { classes, courseName, imgUrl, courseOffer } = this.props;
    return (
      <Card className={classes.card}>
        <CardMedia
          className={classes.media}
          image={imgUrl}
          title={courseName}
        />
        <CardContent>
          <Typography className={classes.name} gutterBottom variant="title">
            {courseName}
          </Typography>
          <Typography component="p">
            {courseOffer}
          </Typography>
        </CardContent>
        <CardActions>
          <Button size="small" color="primary">
            Share
          </Button>
          <Button size="small" color="primary">
            Learn More
          </Button>
        </CardActions>
      </Card>
    );
  }
}

CourseCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CourseCard);



// WEBPACK FOOTER //
// ./src/components/AppCourse/CourseCard.jsx